import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Skeleton from "@material-ui/lab/Skeleton";
import ListItem from "@material-ui/core/ListItem";

import { publicImageUrl } from "../../../Config/publicImageUrl";
import { useStyles } from "./UserProfile.css";

class TeacherDetails extends Component {
  render() {
    const { classes, userDetails } = this.props;
    return (
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
          <Paper className={classes.paper}>
            {userDetails.profileImage ? (
              <img
                src={`${publicImageUrl}/${userDetails.profileImage}`}
                alt={userDetails.fullName}
                style={{ width: 100, height: 100 }}
              />
            ) : (
              <Skeleton variant="circle" style={{ width: 100, height: 100 }} />
            )}
            <ListItem divider>
              <b style={{ flexGrow: 1 }}>Full Name:</b>
              <div>{userDetails.fullName}</div>
            </ListItem>
            <ListItem divider>
              <b style={{ flexGrow: 1 }}>Gender:</b>
              <div>{userDetails.gender}</div>
            </ListItem>
            <ListItem divider>
              <b style={{ flexGrow: 1 }}>Contract:</b>
              <div>{userDetails.contractType}</div>
            </ListItem>
            <ListItem divider>
              <b style={{ flexGrow: 1 }}>Department:</b>
              <div>{userDetails.department}</div>
            </ListItem>
            <ListItem divider>
              <b style={{ flexGrow: 1 }}>Designation:</b>
              <div>{userDetails.designation}</div>
            </ListItem>
            <ListItem divider>
              <b style={{ flexGrow: 1 }}>Joined Date:</b>
              <div>{userDetails.joinedDate}</div>
            </ListItem>
          </Paper>
        </Grid>

        <Grid item container xs={12} sm={12} md={8} lg={8} xl={8}>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            xl={6}
            className={classes.gridMobile}
          >
            <Paper className={classes.paper}>
              <div>General Information</div>

              <ListItem divider>
                <b style={{ flexGrow: 1 }}>Mobile Number:</b>
                <div>{userDetails.mobileNumber}</div>
              </ListItem>
              <ListItem divider>
                <b style={{ flexGrow: 1 }}>Email:</b>
                <div>{userDetails.email}</div>
              </ListItem>
              <ListItem divider>
                <b style={{ flexGrow: 1 }}>Marital Status:</b>
                <div>{userDetails.maritalStatus}</div>
              </ListItem>
              <ListItem divider>
                <b style={{ flexGrow: 1 }}>Date of Birth:</b>
                <div>{userDetails.dateOfBirth}</div>
              </ListItem>
              <ListItem divider>
                <b style={{ flexGrow: 1 }}>Blood Group:</b>
                <div>{userDetails.bloodGroup}</div>
              </ListItem>
            </Paper>
          </Grid>

          {userDetails.bankDetails && (
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              xl={6}
              className={classes.gridMobile}
            >
              <Paper className={classes.paper}>
                <div>Bank Information</div>
                <ListItem divider>
                  <b style={{ flexGrow: 1 }}>Citizenship:</b>
                  <div>{userDetails.citizenshipId}</div>
                </ListItem>
                <ListItem divider>
                  <b style={{ flexGrow: 1 }}>PAN Number:</b>
                  <div>{userDetails.panNumber}</div>
                </ListItem>
                <ListItem divider>
                  <b style={{ flexGrow: 1 }}>Account Number:</b>
                  <div>{userDetails.bankDetails.accountNumber}</div>
                </ListItem>
                <ListItem divider>
                  <b style={{ flexGrow: 1 }}>Bank Name: </b>
                  <div>{userDetails.bankDetails.bankName}</div>
                </ListItem>
                <ListItem divider>
                  <b style={{ flexGrow: 1 }}>Branch Name: </b>
                  <div>{userDetails.bankDetails.branchName}</div>
                </ListItem>
              </Paper>
            </Grid>
          )}
          {userDetails.permanentAddress && (
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              xl={6}
              className={classes.gridMobile}
            >
              <Paper className={classes.paper}>
                <div>Permanent Address</div>
                <ListItem divider>
                  <b style={{ flexGrow: 1 }}>VDC: </b>
                  <div>{userDetails.permanentAddress.vdc}</div>
                </ListItem>
                <ListItem divider>
                  <b style={{ flexGrow: 1 }}>City: </b>
                  <div>{userDetails.permanentAddress.city}</div>
                </ListItem>
                <ListItem divider>
                  <b style={{ flexGrow: 1 }}>District: </b>
                  <div>{userDetails.permanentAddress.district}</div>
                </ListItem>
                <ListItem divider>
                  <b style={{ flexGrow: 1 }}>Province: </b>
                  <div>{userDetails.permanentAddress.province}</div>
                </ListItem>
                <ListItem divider>
                  <b style={{ flexGrow: 1 }}>Country: </b>
                  <div>{userDetails.permanentAddress.country}</div>
                </ListItem>
              </Paper>
            </Grid>
          )}
          {userDetails.temporaryAddress && (
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              xl={6}
              className={classes.gridMobile}
            >
              <Paper className={classes.paper}>
                <div>Temporary Address</div>
                <ListItem divider>
                  <b style={{ flexGrow: 1 }}>VDC: </b>
                  <div>{userDetails.temporaryAddress.vdc}</div>
                </ListItem>
                <ListItem divider>
                  <b style={{ flexGrow: 1 }}>City: </b>
                  <div>{userDetails.temporaryAddress.city}</div>
                </ListItem>
                <ListItem divider>
                  <b style={{ flexGrow: 1 }}>District: </b>
                  <div>{userDetails.temporaryAddress.district}</div>
                </ListItem>
                <ListItem divider>
                  <b style={{ flexGrow: 1 }}>Province: </b>
                  <div>{userDetails.temporaryAddress.province}</div>
                </ListItem>
                <ListItem divider>
                  <b style={{ flexGrow: 1 }}>Country: </b>
                  <div>{userDetails.temporaryAddress.country}</div>
                </ListItem>
              </Paper>
            </Grid>
          )}
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(useStyles)(TeacherDetails);
